import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSignal({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20a2 2 0 110-4 2 2 0 010 4zm4.251-6.234a1 1 0 11-1.417 1.411A3.984 3.984 0 0012 14a3.984 3.984 0 00-2.828 1.172 1 1 0 11-1.414-1.415A5.983 5.983 0 0112 12c1.616 0 3.133.643 4.251 1.766zm2.817-2.84a1 1 0 01-1.414 1.414A7.97 7.97 0 0012 10a7.97 7.97 0 00-5.653 2.339 1 1 0 01-1.413-1.415A9.97 9.97 0 0112 8a9.97 9.97 0 017.068 2.925zm2.83-2.828a1 1 0 01-1.415 1.415A11.957 11.957 0 0012 6C8.778 6 5.76 7.275 3.524 9.506A1 1 0 112.11 8.09 13.957 13.957 0 0112.001 4c3.76 0 7.289 1.492 9.896 4.098z"
        fill={color}
      />
    </svg>
  )
}

export default SvgSignal
